import React from "react";

const MapSection = () => {
  // Function to handle click on the map container
  const handleMapClick = () => {
    // Open the Google Maps link in a new tab (direct link with marker)
    window.open("https://maps.app.goo.gl/Gyyv2ioah3ww5Bt18", "_blank");
  };

  return (
    <div className="w-full px-4 py-[60px] md:px-[80px] md:pb-[100px]">
      {/* Full map is clickable */}
      <div
        className="w-full relative cursor-pointer"
        onClick={handleMapClick}
      >
        {/* Embed map with location already centered + marker */}
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7612.76987164477!2d78.4988745!3d17.4412806!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9b5443733331%3A0x5b7c6c53446fce8d!2sAgastya%20Agro%20Limited!5e0!3m2!1sen!2sin!4v1757141601139!5m2!1sen!2sin"
          width="100%"
          // height="540"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Location Map"
          className="rounded-[40px] pointer-events-none h-[272px] md:h-[540px]"
          ></iframe>

        {/* Overlay instruction
        <div className="absolute bottom-4 right-16 bg-white bg-opacity-80 p-2 rounded-md shadow-md">
          <p className="text-sm font-medium">Click map to open in Google Maps</p>
        </div> */}
      </div>
    </div>
  );
};

export default MapSection;
